import { ThreeApp } from "../work-modules/017/game";

window.addEventListener(
  "DOMContentLoaded",
  async () => {
    const canvas: HTMLCanvasElement | null = document.querySelector("#webgl-canvas");
    if (!canvas) {
      return;
    }

    const app = new ThreeApp(canvas);
    await app.load();
    app.init();
    app.render();
  },
  false
);
